import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import { addData, getList } from "../../helpers/fackBackend_Helper";

function* getPlanWiseMappingResponse({ payload: { data } }) {
  try {
    const response = yield call(addData, "/getAllNetworkPlans", data);
    if (response.Status) {
      yield put(actions.getPlanWiseMappingSuccess(response.Data));
    } else {
      yield put(actions.getPlanWiseMappingFailed(response.Message));
    }
  } catch (error) {
    yield put(actions.getPlanWiseMappingFailed(error.Message));
  }
}

function* getAllPlanPriceMappingDataResponse({ payload: { data } }) {
  try {
    const response = yield call(addData, "/getPlanPriceMapping", data);
    if (response.Status) {
      yield put(actions.getAllPlanPriceMappingDataSuccess(response.Data));
    } else {
      yield put(actions.getAllPlanPriceMappingDataFailed(response.Message));
    }
  } catch (error) {
    yield put(actions.getAllPlanPriceMappingDataFailed(error.Message));
  }
}

function* updatePlanPriceMappingDataResponse({ data, searchData }) {
  try {
    const response = yield call(addData, "/planPriceMapping", data);
    if (response.Status) {
      const responseList = yield call(
        addData,
        "/getPlanPriceMapping",
        searchData,
      );
      if (responseList.Status) {
        yield put(
          actions.updatePlanPriceMappingDataSuccess(
            response.Data[0].Message,
            responseList.Data,
          ),
        );
      } else {
        yield put(actions.getPlanWiseMappingFailed(response.Data[0].Message));
      }
    } else {
      yield put(actions.getPlanWiseMappingFailed(response.Data[0].Message));
    }
  } catch (error) {
    yield put(actions.updatePlanPriceMappingDataFailed(error.Message));
  }
}

function* updateRechargeMappingDataResponse({ payload: { data } }) {
  try {
    const response = yield call(addData, "/rechargeMapping", data);
    if (response.Status) {
      yield put(actions.updateRechargeMappingDataSuccess(response.Message));
      yield put(actions.getRechargeMapping());
    } else {
      yield put(actions.updateRechargeMappingDataFailed(response.Message));
    }
  } catch (error) {
    yield put(actions.updateRechargeMappingDataFailed(error.Message));
  }
}

function* checkRechargeMappingExistsDataResponse() {
  try {
    const response = yield call(getList, "/checkRechargeMappingExist");
    if (response.Status) {
      yield put(actions.checkRechargeMappingExistsSuccess(response.Message));
    } else {
      yield put(actions.checkRechargeMappingExistsFailed(response.Message));
    }
  } catch (error) {
    yield put(actions.checkRechargeMappingExistsFailed(error.Message));
  }
}

function* updateRechargeMappingByDealerIDResponse({
  payload: { dealerId, data },
}) {
  try {
    const response = yield call(
      addData,
      "/updateRechargeMapping/" + dealerId,
      data,
    );
    if (response.Status) {
      yield put(
        actions.updateRechargeMappingByDealerIdSuccess(response.Message),
      );
      yield put(actions.getRechargeMapping());
    } else {
      yield put(
        actions.updateRechargeMappingByDealerIdFailed(response.Message),
      );
    }
  } catch (error) {
    yield put(actions.updateRechargeMappingByDealerIdFailed(error.Message));
  }
}

function* updatePlanPriceMappingByDealerIDResponse({
  payload: { dealerId, data, searchData },
}) {
  try {
    const response = yield call(
      addData,
      "/updatePlanPriceMapping/" + dealerId,
      data,
    );
    if (response.Status) {
      yield put(
        actions.updatePlanPriceMappingByDealerIdSuccess(response.Message),
      );
      yield put(actions.getAllPlanPriceMappingData(searchData));
    } else {
      yield put(
        actions.updatePlanPriceMappingByDealerIdFailed(response.Message),
      );
    }
  } catch (error) {
    yield put(actions.updatePlanPriceMappingByDealerIdFailed(error.Message));
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.GET_PLAN_WISE_MAPPING, getPlanWiseMappingResponse),
  ]);
  yield all([
    takeEvery(
      actions.GET_ALL_PLAN_PRICE_MAPPING_DATA,
      getAllPlanPriceMappingDataResponse,
    ),
  ]);
  yield all([
    takeEvery(
      actions.UPDATE_PLAN_PRICE_MAPPING_DATA,
      updatePlanPriceMappingDataResponse,
    ),
  ]);
  yield all([
    takeEvery(
      actions.UPDATE_RECHARGE_MAPPING_DATA,
      updateRechargeMappingDataResponse,
    ),
  ]);
  yield all([
    takeEvery(
      actions.CHECK_RECHARGE_MAPPING_EXISTS,
      checkRechargeMappingExistsDataResponse,
    ),
  ]);

  yield all([
    takeEvery(
      actions.UPDATE_RECHARGE_MAPPING_BY_DEALERID,
      updateRechargeMappingByDealerIDResponse,
    ),
  ]);
  yield all([
    takeEvery(
      actions.UPDATE_PLAN_PRICE_MAPPING_BY_DEALERID,
      updatePlanPriceMappingByDealerIDResponse,
    ),
  ]);
}
